import React, { useEffect, useState } from "react";
import Layout from "./layout";
import {  LOCAL_API_URL } from "../../../path";
import useApiGet from "../../../Hooks/useGet";
import useApiPost from "../../../Hooks/usePost";
import { useParams } from "react-router-dom";

const Collegedata = () => {
  const { id, flyear } = useParams();

  // =========================================================
  // FILTER STATES
  // =========================================================
  const [BatchYear, setBatchYear] = useState([]);
  const [Shift, setShift] = useState([]);
  const [BranchCode, setBranchCode] = useState([]);
  const FilterOptions = useApiGet(
  `${LOCAL_API_URL}college/dashboard/filter_options?selected_college_id=${id}`
);

  // =========================================================
  // API HOOKS
  // =========================================================
  const Totalcount = useApiPost(
    `${LOCAL_API_URL}college/dashboard/total_registration`
  );

  const TopStudent = useApiPost(
    `${LOCAL_API_URL}college/dashboard/top_students`
  );

  const PreferredGoals = useApiPost(
    `${LOCAL_API_URL}college/dashboard/preferred_goals`
  );

  const PreferredActions = useApiPost(
    `${LOCAL_API_URL}college/dashboard/preferred_actions`
  );

  const Monthlydata = useApiPost(
    `${LOCAL_API_URL}college/dashboard/monthly_analysis`
  );

  // =========================================================
  // COMMON FILTER PAYLOAD
  // =========================================================
  const getFilterPayload = () => {
    return {
      selected_college_id: id,

      ...(BatchYear.length > 0 && {
        batch_year: BatchYear.map(Number),
      }),

      ...(Shift.length > 0 && {
        shift: Shift,
      }),

      ...(BranchCode.length > 0 && {
        branch_code: BranchCode,
      }),
    };
  };

  // =========================================================
  // CLEAN UP API DATA WHEN LEAVING THE PAGE
  // =========================================================
  useEffect(() => {
  if (id) {
    FilterOptions.getdata();
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [id]);
  useEffect(() => {
    return () => {
      Totalcount.setData(null);
      TopStudent.setData(null);
      PreferredGoals.setData(null);
      PreferredActions.setData(null);
      Monthlydata.setData(null);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // =========================================================
  // 1. TOTAL REGISTRATION
  //
  // Payload:
  // selected_college_id
  // batch_year
  // shift
  // branch_code
  // =========================================================
  useEffect(() => {
    const payload = getFilterPayload();

    Totalcount.postData(payload);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, BatchYear, Shift, BranchCode]);

  // =========================================================
  // 2. TOP STUDENTS
  //
  // Payload:
  // selected_college_id
  // batch_year
  // shift
  // branch_code
  // =========================================================
  useEffect(() => {
    const payload = getFilterPayload();

    TopStudent.postData(payload);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, BatchYear, Shift, BranchCode]);

  // =========================================================
  // 3. PREFERRED GOALS
  //
  // Payload:
  // selected_college_id
  // batch_year
  // shift
  // branch_code
  // =========================================================
  useEffect(() => {
    const payload = getFilterPayload();

    PreferredGoals.postData(payload);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, BatchYear, Shift, BranchCode]);

  // =========================================================
  // 4. PREFERRED ACTIONS
  //
  // Payload:
  // selected_college_id
  // batch_year
  // shift
  // branch_code
  // =========================================================
  useEffect(() => {
    const payload = getFilterPayload();

    PreferredActions.postData(payload);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, BatchYear, Shift, BranchCode]);

  // =========================================================
  // 5. MONTHLY ANALYSIS
  //
  // Payload:
  // selected_college_id
  // year
  // batch_year
  // shift
  // branch_code
  //
  // `year` is ONLY for monthly_analysis.
  // =========================================================
  useEffect(() => {
    const payload = {
      ...getFilterPayload(),

      year: Number(flyear),
    };

    Monthlydata.postData(payload);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, flyear, BatchYear, Shift, BranchCode]);

  // =========================================================
  // RENDER
  // =========================================================
  return (
    <div className="h-full">
      <Layout
      Totalcount={Totalcount}
      TopStudent={TopStudent}
      PreferredGoals={PreferredGoals}
      PreferredActions={PreferredActions}
      Monthlydata={Monthlydata}
      FilterOptions={FilterOptions}
      BatchYear={BatchYear}
      setBatchYear={setBatchYear}
      Shift={Shift}
      setShift={setShift}
      BranchCode={BranchCode}
      setBranchCode={setBranchCode}
    />
    </div>
  );
};

export default Collegedata;